import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import {
  flattenData,
  getDaysInFYMonths,
  secondsToHHMM,
} from "../../../Utilitie";
import NKJYardCharts from "./NkjCharts/NKJYardCharts";

const NKJYardFyearWise = ({ data }) => {
  const years = [...new Set(data.map((o) => o.F_YEAR))];
  const monthOrder = [
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  const tableRef = useRef();

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">
        NKJ YARD EXAMINATION FINANCIAL YEAR WISE SUMMARY
      </h6>
      <div className="row">
        <div className="col-md-6  border">
          <div className="table-responsive d-flex flex-column h-100">
            <table
              ref={tableRef}
              className="table table-bordered table-striped text-center flex-grow-1"
              // style={{ fontSize: "13px" }}
            >
              <thead className="table-dark">
                <tr>
                  {" "}
                  <th rowSpan={2}>F_YEAR</th>
                  <th colSpan={3}>AVG PER DAY</th>
                  <th colSpan={3}>TOTAL</th>
                </tr>
                <tr>
                  <th> CC</th>
                  <th> PREMIUM</th>
                  <th> AVG EXAM TIME</th> <th> CC</th>
                  <th> PREMIUM</th>
                  <th> AVG EXAM TIME</th>
                </tr>
              </thead>

              <tbody>
                {years.map((year, i) => {
                  let tempMonths = [
                    ...new Set(
                      data.filter((o) => o.F_YEAR === year).map((o) => o.MONTH),
                    ),
                  ];
                  let months = tempMonths.sort(
                    (a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b),
                  );
                  let days = tempMonths
                    ? getDaysInFYMonths(year.replace("-", "_"), months)
                    : 1;

                  return (
                    <tr key={i}>
                      <td>{year}</td>
                      <td>
                        {(
                          data
                            .filter((o) => o.F_YEAR === year)
                            .reduce((sum, o) => {
                              return sum + o.EX_TY_CC;
                            }, 0) / days
                        ).toFixed(2)}
                      </td>
                      <td>
                        {" "}
                        {(
                          data
                            .filter((o) => o.F_YEAR === year)
                            .reduce((sum, o) => {
                              return sum + o.EX_TY_PREMIUM;
                            }, 0) / days
                        ).toFixed(2)}
                      </td>
                      <td>
                        {" "}
                        {secondsToHHMM(
                          (
                            data
                              .filter((o) => o.F_YEAR === year)
                              .reduce((sum, o) => {
                                return sum + o.AVG_EXAM_TIME;
                              }, 0) / months.length
                          ).toFixed(0),
                        )}
                      </td>

                      {/* ////////////////////// */}

                      <td>
                        {data
                          .filter((o) => o.F_YEAR === year)
                          .reduce((sum, o) => {
                            return sum + o.EX_TY_CC;
                          }, 0)}
                      </td>
                      <td>
                        {" "}
                        {data
                          .filter((o) => o.F_YEAR === year)
                          .reduce((sum, o) => {
                            return sum + o.EX_TY_PREMIUM;
                          }, 0)}
                      </td>
                      <td>
                        {" "}
                        {secondsToHHMM(
                          data
                            .filter((o) => o.F_YEAR === year)
                            .reduce((sum, o) => {
                              return sum + o.AVG_EXAM_TIME;
                            }, 0),
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <DownloadExcel
              tableRef={tableRef}
              fileName={`Financial Year Summary NKJ Yard Ex  -}`}
            />
          </div>
        </div>
        <div className="col-md-6">
          <NKJYardCharts data={data} />
        </div>
      </div>
    </div>
  );
};

export default NKJYardFyearWise;
